/* stylelint-disable selector-class-pattern -- Ant Design global .ant-* classes used in :global blocks */

.createdAt {
  margin-right: 5px;
  color: var(--x-color-text-secondary);
  font-size: 12px;
}

.span {
  color: var(--x-color-action);
}

.ellipsisedText {
  overflow: hidden;
  max-width: 145px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fileWrap {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 3px;

  background: var(--x-color-background);
  gap: 8px;

  :global {
    .ant-image {
      display: none;
    }

    .name {
      display: inline-flex;
    }

    .button {
      display: flex;
      min-width: 0;
      align-items: center;
    }
  }
}

.upload.upload {
  display: flex;
  justify-content: center;

  svg {
    margin-top: 7px;
    margin-bottom: 5px;
    color: var(--x-color-text-secondary);
    font-size: 30px;
  }

  :global {
    .ant-upload {
      height: 90px;
      flex-direction: column;
      margin-right: 0;
      margin-bottom: 11px;
    }
  }
}

.uploadButton:global(.ant-btn-link) {
  span {
    text-decoration: none;
  }
}

.uploadModal {
  :global {
    .ant-modal-content {
      height: calc(100vh - 80px);
    }

    /* stylelint-disable declaration-no-important -- preserve original emotion !important verbatim (landmine policy) */

    iframe {
      top: 55px !important;
    }
    /* stylelint-enable declaration-no-important */
  }
}
